import SearchNotFoundIconDuotone from '@/components/icons/SearchNotFoundIconDuotone';
import { t } from 'i18next';

const OwnersListMobileEmpty = () => {
	return (
		<div className='h-full flex-1 flex flex-col items-center justify-center gap-2'>
			<SearchNotFoundIconDuotone className='size-8' />
			<div className='w-80 flex flex-col gap-1 text-center'>
				<h3 className='text-lg font-medium'>
					{t('No owners yet!')}
				</h3>
				<p className='text-sm text-popover-600'>
					{t('Owners will appear here automatically when they are added to the system. No manual action is needed.')}
				</p>
			</div>
		</div>
	);
};

export default OwnersListMobileEmpty;
